export class KnowledgeActivityNotFoundError extends Error { }
